import { Attachment, AttachMoney, Cancel, Check, Close, MoneyOff, Receipt } from "@mui/icons-material"
import { Box, Chip, IconButton, Paper, Stack, Typography } from "@mui/material"
import { MeioPagMov } from "../../../../data.types"
import { formatMoney, isEmpty } from "../../../../services/utils"
import { handleShowCadContasModal } from "../../../contas/view/contas.list"
import { FormCad } from "../../../../components/viewCadastro/formCad"
import Modal from "../../../../components/modal"
import { useCallback, useState } from "react"
import { Anexar, AnexoProvider, useAnexo } from "../../../../components/anexar"
import { galeriaController } from "../../../galeria/galeria.controll"

interface CardMeioPagMovProps {
    mp: MeioPagMov
    mutatorLocal: (v: any, field: string) => any
}

export const CardMeioPagMov = (props: CardMeioPagMovProps) => {
    const [showModalSituacaoMp, setShowModalSituacaoMp] = useState(false)
    const { mp, mutatorLocal } = props;
    const handleAlterarSituacao = (row: MeioPagMov) => {
        mutatorLocal(row, "meioPagUp")
    }
    return (
        <Paper elevation={4}>
            <Box display={"flex"} p={1} flex={1} flexDirection={"column"}>
                <Stack flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography variant="caption">{`${mp.descricao}: ${formatMoney(mp.valor)}`}</Typography>
                    <IconButton
                        size="small"
                        title="Remover pagamento"
                        onClick={() => mutatorLocal(mp, "meioPagRem")}
                    >
                        <Close />
                    </IconButton>
                </Stack>

                <Stack flexDirection={"row"} flex={1} justifyContent={"space-between"} alignItems={"center"} gap={1}>
                    <Chip
                        label={mp.sit_pag}
                        size="medium"
                        variant="outlined"
                        color={mp.sit_pag === "aberto" ? "error" : "success"}
                        icon={mp.sit_pag === "aberto" ? <MoneyOff /> : <AttachMoney />}
                        onClick={() => setShowModalSituacaoMp(true)}
                        onDelete={mp.anexo ? () => { } : undefined}
                        deleteIcon={<Attachment />}
                    />
                    {mp._id_conta && (
                        <Chip
                            label={"Conta"}
                            size="medium"
                            variant="outlined"
                            color="primary"
                            icon={<Receipt titleAccess="Abrir conta gerada" />}
                            onClick={() => handleShowCadContasModal(true, mp._id_conta)}
                        />
                    )}
                </Stack>
            </Box>
            <CadSituacaoMpMov
                handleClose={() => setShowModalSituacaoMp(false)}
                handleSubmit={handleAlterarSituacao}
                row={mp}
                showModal={showModalSituacaoMp}
            />
        </Paper>
    )
}

interface CadSituacaoMpMovProps {
    handleSubmit: (value: MeioPagMov) => any
    row: MeioPagMov
    handleClose: () => any
    showModal: boolean
}

const CadSituacaoMpMov = (props: CadSituacaoMpMovProps) => {
    const { handleSubmit, row, handleClose, showModal } = props
    const Formulario = () => {
        const { handleShowModal, urlAtual, handleCloseModal, handleSetUrl } = useAnexo()

        const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
            changeValue(state, field, () => value)
        }
        return (
            <FormCad
                handleOnSubmit={handleSubmit}
                //formValidation={}
                handleMutator={handleMutator}
                handleCancel={() => { }}
                row={row}
                contentForm={[
                    {
                        fieldName: "sit_pag", label: "Situação do pagamento", type: "radio", key: "sit_pag",
                        radioDefaultValue: "aberto",
                        radioOptionsValues: [{ label: "Aberto", value: "aberto" }, { label: "Pago", value: "pago" }],
                        colunsXS: 6, colunsSM: 6, colunsMD: 6,
                    },
                    {
                        fieldName: "anexo", label: "Comprovante", type: "anexo", key: "anexo",
                        propsAnexoField: { handleShowAnexo: () => handleShowModal(), urlAnexo: urlAtual },
                        ViewSelecionarDialog:(propsView => {
                            const { handleMutator, valuesForm } = propsView
                            return (
                                <Anexar
                                    idAnexoAtual={valuesForm.anexo}
                                    getBlobAnexo={async (id) => {
                                        if (urlAtual === '') {
                                            let resp = await galeriaController.getImagem(id)
                                            if (resp.status === "ok")
                                                handleSetUrl(resp.data)
                                        }
                                    }}
                                    postAnexo={async (file) => {
                                        let resp = await galeriaController.putImagem(file)
                                        if (resp.status === "ok" && resp.id) {
                                            return { id: resp.id }
                                        }

                                        return { id: "" }

                                    }}
                                    handleChangeId={(id) => {
                                        handleMutator(id, "anexo");
                                        handleCloseModal();
                                    }}
                                />
                            )
                        }),
                        colunsXS: 6, colunsSM: 6, colunsMD: 6,
                    }

                ]}
                buttonActions={[
                    { label: "Cancelar", icon: <Cancel />, color: "error", variant: "contained", handleOnClick: (row) => handleClose(), disableType: "personalizado", disabled: () => false },
                    { label: "Confirmar", icon: <Check />, color: "success", variant: "contained", type: "submit", disableType: "padraoForm" }

                ]}
                ContentBox={(props) => { console.log("propsFormMp", props); return <div></div> }}

            />
        )
    }


    return (
        <Modal
            component={
                <AnexoProvider>
                    <Formulario />
                </AnexoProvider>
            }
            handleClose={handleClose}
            open={showModal}
            width="sm"
            heigth="auto"
            handleOnKeyDown={(ev: any) => {
                console.log("ev", ev)
            }}
        />

    )
}